export const routeConfig = {
  "*": {
    "/": "*",
  },
  "/": "/",
  appComparison: {
    "/": "/app-comparison",
  },
  billing: {
    "/": "/billing",
  },
  duplicates: {
    "/": "/duplicates",
    ":id": {
      "/": "/duplicates/:id",
    },
  },
  extensions: {
    "/": "/extensions",
  },
  leaks: {
    "/": "/leaks",
    ":id": {
      "/": "/leaks/:id",
    },
  },
  linkblocking: {
    "/": "/linkblocking",
    ":id": {
      "/": "/linkblocking/:id",
    },
    create: {
      "/": "/linkblocking/create",
    },
  },
  settings: {
    "/": "/settings",
  },
} as const;
